import React from 'react';
import { Modal } from 'antd';
import { ExclamationCircleOutlined } from '@ant-design/icons';

interface DisconnectIntegrationModalProps {
    isOpen: boolean;
    onCancel: () => void;
    onConfirm: () => Promise<void>;
}

const DisconnectIntegrationModal: React.FC<DisconnectIntegrationModalProps> = ({
    isOpen,
    onCancel,
    onConfirm
}) => {
    return (
        <Modal
            title="Disconnect Integration"
            open={isOpen}
            onOk={onConfirm}
            onCancel={onCancel}
            okText="Disconnect"
            cancelText="Cancel"
            okButtonProps={{
                danger: true,
                className: 'btn-danger'
            }}
            className="p-0"
            centered
        >
            <div className="text-center py-4">
                <div className="mb-3">
                    <ExclamationCircleOutlined className="text-warning" style={{ fontSize: '2.5rem' }} />
                </div>
                <p className="mb-0">
                    Are you sure you want to disconnect this integration?
                </p>
            </div>
        </Modal>
    );
};

export default DisconnectIntegrationModal; 